document.addEventListener("DOMContentLoaded", function () {
  // Only run for UK market visitors
  if (window.marketCountry === "GB") {
    // Get all product prices on the page
    var productPrices = document.querySelectorAll(".price-item");

    productPrices.forEach(function (priceElement) {
      // Get the original price text
      var originalPriceText = priceElement.innerText;
      var hasFrom = originalPriceText.includes("From");
      var priceText = originalPriceText.replace("From", "").replace(/[^0-9.]/g, "");
      var price = parseFloat(priceText); // Convert the cleaned price to a float
  
      var vatRate = 0.20; // 20% VAT rate
      
      var inclusivePrice = (price + price * vatRate).toFixed(2);
      var exclusivePrice = price.toFixed(2);
  
      // Create elements to display both prices
      var priceContainer = document.createElement("div");
      var inclusivePriceElement = document.createElement("span");
      inclusivePriceElement.innerHTML = "£" + inclusivePrice + " incl VAT";
      var exclusivePriceElement = document.createElement("span");
      exclusivePriceElement.innerHTML = "£" + exclusivePrice;

      // Check if "From" existed in the original price and include it
      if (hasFrom) {
        priceContainer.innerHTML = "From " + exclusivePriceElement.outerHTML + "<br>" + "<small><small>(From " + inclusivePriceElement.outerHTML + ")</small></small>";
      } else {
        priceContainer.innerHTML = exclusivePriceElement.outerHTML + "<br>" + "<small><small>(" + inclusivePriceElement.outerHTML + ")</small></small>";
      }
      // Replace the original price with the price container
      priceElement.innerHTML = priceContainer.outerHTML;
    });
  }
});
